import { render, staticRenderFns } from "./booked-bags.vue?vue&type=template&id=6b7ce42a&scoped=true"
import script from "./booked-bags.vue?vue&type=script&lang=js"
export * from "./booked-bags.vue?vue&type=script&lang=js"
import style0 from "./booked-bags.vue?vue&type=style&index=0&id=6b7ce42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ce42a",
  null
  
)

export default component.exports